import React, { useContext, useEffect, useState } from "react";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import 'moment/locale/en-gb';
import "./rcaCustom.css";

import RcaDropdowns from "./RcaDropdowns";
import WaterMark from "../DashboardMain_Bus/WaterMark";

export default function RcaToggler(props) {

  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [dropdownData, setDropdownData] = useState([]);
  const [dropdownDataB, setDropdownDataB] = useState([]);
  const [dropdownDataC, setDropdownDataC] = useState([]);
  function add(arr, name) {
    const { length } = arr;
    const id = length + 1;
    const found = arr.some(el => el.elemntId === name);
    if (found) {
      setGoTher(true)
      let spliceres = arr.splice(arr.findIndex(el => el.elemntId === name), 1);
    }
  }

  const [grupName, setGrupName] = useState("")
  const [goTher, setGoTher] = useState(true)
  const updateDropdownData = async (updatedData, grupName) => {
    setGrupName(grupName)
    if (grupName === "A") {
      if (updatedData.ecu !== null && updatedData.axis !== null && updatedData.signal !== null && updatedData.elemntId !== '') {
        setGoTher(true)
        await add(dropdownData, updatedData.elemntId)
        await setDropdownData([...dropdownData, updatedData]);
      } else {
        setGoTher(false)
        await add(dropdownData, updatedData.elemntId)
        await setDropdownData([...dropdownData]);
      }
    } else if (grupName === "B") {
      if (updatedData.ecu !== null && updatedData.axis !== null && updatedData.signal !== null && updatedData.elemntId !== '') {
        setGoTher(true)
        await add(dropdownDataB, updatedData.elemntId)
        await setDropdownDataB([...dropdownDataB, updatedData]);
      } else {
        setGoTher(false)
        await add(dropdownDataB, updatedData.elemntId)
        await setDropdownDataB([...dropdownDataB]);
      }
    } else {
      if (updatedData.ecu !== null && updatedData.signal !== null && updatedData.elemntId !== '') {
        setGoTher(true)
        await add(dropdownDataC, updatedData.elemntId)
        await setDropdownDataC([...dropdownDataC, updatedData]);
      } else {
        setGoTher(false)
        await add(dropdownDataC, updatedData.elemntId)
        await setDropdownDataC([...dropdownDataC]);
      }
    }
  };

  const [dataJson, setDataJosn] = useState([])
  const getEcuRes = (data) => {
    let tempArr = []
    data.forEach(element => {
      tempArr.push({ "region": element.key.ECU })
    });
    setDataJosn(tempArr)
  }

  useEffect(() => {
    if (props.filterObject.vin_no !== '') {
      fetchData({ url: API_URL_MAIN + "rca/getEcu", body: { filterdata: props.filterObject } }, getEcuRes)
    }
  }, [props.filterObject])

  useEffect(() => {
    if (dropdownData.length > 0 && grupName === "A") {
      if (goTher) {
        props.userSelectedData(dropdownData, grupName)
      }
    }
    if (dropdownDataB.length > 0 && grupName === "B") {
      if (goTher) {
        props.userSelectedData(dropdownDataB, grupName)
      }
    }
    if (dropdownDataC.length > 0 && grupName === "C") {
      if (goTher) {
        props.userSelectedData(dropdownDataC, grupName)
      }
    }
  }, [dropdownData, dropdownDataB, dropdownDataC])

  return (
    <>
      <div className="row" style={{ display: (props.commanHideShow === "1st") ? "block" : "none" }}>
        <WaterMark />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA1" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA2" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA3" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA4" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA5" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA6" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA7" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA8" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA9" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA10" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA11" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA12" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA13" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA14" grupName="A" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupA15" grupName="A" />
      </div>

      <div className="row" style={{ display: (props.commanHideShow == "2nd") ? "block" : "none" }}>
        <WaterMark />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB1" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB2" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB3" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB4" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB5" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB6" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB7" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB8" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB9" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB10" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB11" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB12" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB13" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB14" grupName="B" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupB15" grupName="B" />
      </div>

      <div className="row" style={{ display: (props.commanHideShow == "3nd") ? "block" : "none" }}>
        <WaterMark />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC1" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC2" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC3" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC4" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC5" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC6" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC7" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC8" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC9" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC10" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC11" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC12" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC13" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC14" grupName="C" />
        <RcaDropdowns dataJson={dataJson} filterObject={props.filterObject} onUpdateDropdownData={updateDropdownData} grupId="grupC15" grupName="C" />
      </div>
    </>
  );
}
